import React, { useEffect, useRef, useState } from "react";
import { List, X } from "@phosphor-icons/react";
import { RESORTS } from "../data";

const ResortPicker = (props: {
  currentResortKey: string;
  onSelectResort: (resortKey: string) => void;
}) => {
  const { currentResortKey, onSelectResort } = props;
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") setIsOpen(false);
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  return (
    <div ref={menuRef} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex h-11 w-11 items-center justify-center rounded-full bg-white drop-shadow transition-opacity hover:opacity-80"
        aria-label="Select resort"
      >
        {isOpen ? (
          <X size={20} weight="bold" className="text-gray-950" />
        ) : (
          <List size={20} weight="bold" className="text-gray-950" />
        )}
      </button>
      {isOpen && (
        <div className="absolute left-0 top-full mt-2 w-56 overflow-hidden rounded-xl bg-white shadow-lg">
          {Object.entries(RESORTS).map(([key, resort]) => (
            <button
              key={key}
              onClick={() => {
                onSelectResort(key);
                setIsOpen(false);
              }}
              className={`flex w-full items-center gap-3 px-4 py-3 text-left text-sm transition-colors hover:bg-gray-100 ${
                key === currentResortKey
                  ? "bg-gray-100 font-bold text-gray-950"
                  : "text-gray-700"
              }`}
            >
              {resort.title}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ResortPicker;
